import {ButtonBase, Grid, Typography} from "@mui/material";
import {Add, Delete, Remove} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {useProductosCarrito} from "../Funcionamiento/Hooks/useProductosCarrito";


export const useBotonCantidadTarjeta = ({numeroMaximo = 100, cantidad = 1, producto}) => {
    const [cantidad_, setCantidad] = useState(cantidad)
    const {agregarProducto, quitarProducto} = useProductosCarrito()

    const adicionar = (e) => {
        if (e < numeroMaximo) {
            agregarProducto(producto)
        }
    }
    const restar = (e) => {

        quitarProducto(producto)

    }

    useEffect(() => {
        setCantidad(cantidad)
    }, [cantidad]);
    const Boton = () => {

        return (
            <Grid
                container
                justifyContent={'space-between'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={1}

            >

                <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                    <ButtonBase
                        onClick={() => restar(cantidad_)}
                        sx={{
                            borderRadius: 1,
                            backgroundColor: cantidad_ <= 1 ? '#00000050' : '#bdbdbd',
                            p: 0.5
                        }}>
                        {cantidad_ <= 1 ?
                            <Delete sx={{fill: '#00000080', width: 16, height: 16}}/>
                            :
                            <Remove sx={{fill: '#fff', width: 16, height: 16}}/>
                        }
                    </ButtonBase>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{
                        color: '#4d4d4d',
                        borderRadius: 2,
                        fontWeight: 600,
                        fontSize: 20
                    }}>{cantidad_}</Typography>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                    <ButtonBase
                        onClick={() => adicionar(cantidad_)}
                        sx={{borderRadius: 1, backgroundColor: '#bdbdbd', p: 0.5}}>
                        <Add sx={{fill: '#fff', width: 16, height: 16}}/>
                    </ButtonBase>
                </Grid>


            </Grid>
        )

    }

    return {

        Boton,
        cantidad
    }
}

